
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.668 2.5h16.667m-.834 0v9.167a1.667 1.667 0 01-1.666 1.666H4.168a1.667 1.667 0 01-1.667-1.666V2.5m3.334 15L10 13.333l4.167 4.167","stroke":"currentColor","stroke-width":"1.667","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    